import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Document } from '../models/documents/document.model';
import { GridResponse } from '../models/common/grid-response.model';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { Event } from '../models/events/event.model';
import { DocumentGenerator } from '../models/documents/document-generator.model';

@Injectable({
    providedIn: 'root'
})
export class DocumentsService extends BaseService<Document> {
    private baseUrl = '/api/documents';

    getDocumentsByCode(codes: string[]): Observable<GridResponse> {
        let params = new HttpParams();
        codes.forEach(code => {
            params = params.append('codes', code);
        });
        return this.http.get<GridResponse>(`${this.baseUrl}/GetDocumentsByDocumentsType`, { params });
    }

    generateDocument(generator: DocumentGenerator): Observable<string> {
        return this.http.post<string>(`${this.baseUrl}/Generate`, generator);
    }

    openDocument(guid: string): void {
        const url = `${this.baseUrl}/${guid}/download`;
        window.open(url, '_blank');
    }
}
